import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH_CLIENT_CARD = ConstantList.API_EN_POINT + "/client-card";
export const pagingClientCard = (obj) =>
  axios.post(API_PATH_CLIENT_CARD + "/search-by-page", obj);

export const getClientCardById = (id) =>
  axios.get(API_PATH_CLIENT_CARD + "/get-by-id/" + id);

export const saveOrEditClientCard = (id) =>
  axios.post(API_PATH_CLIENT_CARD + "/save-or-update", id);

export const saveIsUsing = (isusing) =>
  axios.post(API_PATH_CLIENT_CARD + "/update-is-using", isusing);

export const deleteClientCard = (id) =>
  axios.delete(API_PATH_CLIENT_CARD + "/mark-delete/" + id);

